import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ToastProvider } from './contexts/ToastContext';
import { ConfirmProvider } from './contexts/ConfirmContext';

// Page imports
import CostCalculator from './pages/cost-calculator';
import DashboardOverview from './pages/dashboard-overview';
import FilamentInventory from './pages/filament-inventory';
import PrinterManagement from './pages/printer-management';
import AuthenticationLogin from './pages/authentication-login';
import EnhancedCostCalculator from './pages/enhanced-cost-calculator';
import ProfitAnalyticsDashboard from './pages/profit-analytics-dashboard';
import History from './pages/history';
import QuickCalculator from './pages/quick-calculator';
import CalculatorHub from './pages/calculator';
import MarketplaceManagement from './pages/marketplace-management';
import SettingsPage from './pages/settings';

const Routes = () => {
  const publicMode = import.meta.env?.VITE_PUBLIC_MODE === 'true';
  const RequireAuth = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return null; // evita flicker enquanto checa sessão
    if (!user && !publicMode) return <Navigate to="/authentication-login" replace />;
    return children;
  };

  const RootRedirect = () => {
    const { user, loading } = useAuth();
    if (loading) return null;
    return <Navigate to={publicMode ? "/dashboard-overview" : (user ? "/dashboard-overview" : "/authentication-login")} replace />;
  };

  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            <ErrorBoundary>
              <ScrollToTop />
              <RouterRoutes>
            {/* Redirect root conforme estado de auth */}
            <Route path="/" element={<RootRedirect />} />
            
            {/* Authentication */}
            <Route path="/authentication-login" element={<AuthenticationLogin />} />
            
            {/* Main application routes (protegidas) */}
            <Route path="/dashboard-overview" element={<RequireAuth><DashboardOverview /></RequireAuth>} />
            <Route path="/enhanced-cost-calculator" element={<RequireAuth><EnhancedCostCalculator /></RequireAuth>} />
            <Route path="/cost-calculator" element={<RequireAuth><CostCalculator /></RequireAuth>} />
            <Route path="/quick-calculator" element={<RequireAuth><QuickCalculator /></RequireAuth>} />
            <Route path="/calculator" element={<RequireAuth><CalculatorHub /></RequireAuth>} />
            <Route path="/filament-inventory" element={<RequireAuth><FilamentInventory /></RequireAuth>} />
            <Route path="/printer-management" element={<RequireAuth><PrinterManagement /></RequireAuth>} />
            <Route path="/marketplace-management" element={<RequireAuth><MarketplaceManagement /></RequireAuth>} />
            <Route path="/configuracoes" element={<RequireAuth><SettingsPage /></RequireAuth>} />
            <Route path="/profit-analytics-dashboard" element={<RequireAuth><ProfitAnalyticsDashboard /></RequireAuth>} />
            <Route path="/historico" element={<RequireAuth><History /></RequireAuth>} />
            
            {/* 404 fallback */}
            <Route path="*" element={<NotFound />} />
              </RouterRoutes>
            </ErrorBoundary>
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;